import { DELETE_BANNERS_START } from '../../types';

export const delete_banners = (payload) => ({
  type: DELETE_BANNERS_START,
  payload,
});
